import NiceModal from '@ebay/nice-modal-react'
import { Autocomplete, Button, Card, Input, Switch, TextField } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { GlobalContext } from '../../context/GlobalContext'
import useApi from '../../hooks/useApi'
import { ModalContainerAnimateDown } from '../gsys-ui/ModalContainer/ModalContainer'
import moment from 'moment'
import haxios from '../../lib/haxios'
import VirtualisedAutocomplete from '../VirtualisedAutocomplete'
import { successToast } from '../../lib/util'

const PartListAddModal = NiceModal.create(({ refetchPartLists }) => {
  const modalContainer = useRef(null)
  const [partList, setPartList] = useState('')
  const [partGroup, setPartGroup] = useState('')

  const handleClose = () => {
    modalContainer.current?.closeModal()
  }

  const handleSave = async () => {
    try {
      await haxios.post(`/connectplus/partlist/create`, {
        name: partGroup,
        list: partList.split(',').map((el) => el.trim())
      })

      await refetchPartLists()
      handleClose()
      successToast(`Part list ${partGroup} has been added successfully.`)
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <ModalContainerAnimateDown ref={modalContainer}>
      <Card className="w-[500px]">
        <div className="flex justify-between items-center p-4 border-b border-b-gray-300">
          <div className="text-2xl font-semibold">Add part list</div>
          <div className="space-x-2">
            <Button variant="text" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave}>
              Add
            </Button>
          </div>
        </div>

        <div className="p-4 space-y-4">
          <TextField
            fullWidth
            label="Part List Name"
            value={partGroup}
            onChange={(e) => setPartGroup(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Part Items (comma separated)"
            value={partList}
            onChange={(e) => setPartList(e.target.value)}
          />
        </div>
      </Card>
    </ModalContainerAnimateDown>
  )
})

export default PartListAddModal
